import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import CheckCircleOutlined from '@mui/icons-material/CheckCircleOutlined';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import { theme } from '@omnigenbiodata/ui';
import { Participant } from '../../../../../../core/types/common.types';

const successTint = theme.palette.success.lighter;

interface ConfirmedParticipantBannerProps {
  participant: Participant;
}

function ConfirmedParticipantBanner({ participant }: ConfirmedParticipantBannerProps) {
  const participantName = [participant.firstName, participant.surname].filter(Boolean).join(' ');

  return (
    <Paper
      elevation={2}
      sx={{
        mb: 3,
        border: 1,
        borderColor: 'success.main',
        bgcolor: successTint,
        overflow: 'hidden',
      }}
    >
      <Box p={2.5}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, flexWrap: 'wrap' }}>
          <CheckCircleOutlined color="success" sx={{ fontSize: 32 }} />

          <Typography variant="h6" component="p" sx={{ fontWeight: 700, color: 'primary.main' }}>
            Participant confirmed:
          </Typography>

          <Chip label={participant.participantRef || 'Not recorded'} color="success" sx={{ fontWeight: 700 }} />

          <Typography variant="h6" component="p" color="text.secondary">
            {participantName || 'Participant name not recorded'}
          </Typography>
        </Box>
      </Box>
    </Paper>
  );
}

export default ConfirmedParticipantBanner;
